export default {
    title: "{agencyName}'s properties",
    in: "in",
    propertiesFound: "properties found",
    toDay: "Today",
    days: "days",
    week: "Week",
    year: "Year",
    month: "Month",
    prev: "Prev",
    next: "Next",
    backToList: "Back to List",
    sorry: "Sorry , we",
    cantFind: "can't find",
    lookingFor: "the page you're looking for...",
    thankYou: "THANK YOU FOR VISITING OUR WEBSITE",
    pleaseContact: "Please contact the Agent for a new URL.",
    ForSale: "SALE",
    ShortTermRental: "Short Rent",
    LongTermRental: "Long Rent",
    showMore: "Show More",
    showLess: "Show Less",
    price: "Price",
    pricePer: "Price per",
    built: "Build",
    terrace: "Terrace",
    garden: "Garden",
    plot: "Plot",
    propTitle: '{subType} {searchType} in {location}',
    propTitleShort: '{subType} in {location}',
    notAvailable: "Not Available",
    notFound: 'Page not found',
    emptyProperties: "No properties were found, please contact your Agent for more information.",
    linkExpired: "Oops, this link has expired. Contact your estate agent to receive an updated property link.",
    newDevelopment: "New Development",
    agencyRaiiNo: "Agency's registration number",
    home: {
        verifyYourURLHere: "Verify your URL here. To do this, login to WhatsApp on your web browser, then copy the URL from WhatsApp to here.",
        pasteUrlHere: "Paste URL here",
        verifyUrl: "Verify URL",
        whatIsPropertyViewer: "What is Property-Viewer.com?",
        thisIsWebsiteIsUsed: "This website is used by Estate Agents to send properties to their clients. It is a product of  {resalesonlinecom} If in doubt, please speak to the Agent who sent your property list to you.",
        howDoesItWork: "كيف يعمل؟",
        inThePast: "في الماضي، كان الوكلاء يرسلون وثائق PDF إلى عملائهم. ومع ذلك، هذه ليست سهلة لعرضها على العديد من الأجهزة. لذلك أنشأنا {propertyviewercom} بحيث يمكن للعميل عرض الخصائص المرسلة إليهم بسهولة أكبر.",
        createAShortList: "سيقوم \"الوكيل\" بإنشاء قائمة قصيرة من الخصائص. عندما يشاركون هذه الخصائص معك، سوف تتلقى رابط. النقر على هذا الرابط سوف تظهر لك خصائص."
    },

    list: {
        propertyTitle: "انقر هنا لعرض المعلومات الخاصة بهذه الخاصية"
    },

    searchType: {
        ForSale: "for sale",
        ShortTermRental: "for short term rent",
        LongTermRental: "for long term rent",
    },

    rsStatus: {
        Available: "Available",
        Listing: "Listing",
        UnderOffer: "Under Offer",
        SaleAgreed: "Sale Agreed",
        OffMarket: "Off Market",
        Sold: "Sold",
        Rented: "Rented"
    },

    details: {
        average: "Average",
        averagePricesFor: "Average prices for ",
        showFullER: "Show Full",
        thisProperty: "This property",
        infoNotAvailable: "This information is not available.",
        feesEnergyRating: "Fees, Energy Rating",
        fees: "Fees",
        ibiFees: "IBI Fees",
        basuraTax: "Basura Tax",
        communityFees: "Community Fees",
        associatedCosts: "Associated Costs",
        energyRating: "Energy Rating",
        securityDeposit: "Security Deposit",
        energyCertificate: "Energy certificate",
        energyCertificatePending: "The energy certificate is pending",
        energyConsumption: "Energy Consumption",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² per year",
        kwhPerYear: "kWh/m² per year",
        other: "Other info",
        buildYear: "Build year",
        forSale: "For sale",
        sold: "Sold",
        longTerm: "Long term",
        shortTermHigh: "Short term high",
        shortTermLow: "Short term low",
        allFeatures: "All features",
        aproxLocation: "Aprox. Location",
        listingAgent: "Listing agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª Transmission Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o Posteriores Transmisiones Impuesto Sobre Transmisiones (ITP) 7%. Además, la formalización en documento público del contrato de compraventa (escrituras) está sujeta a AJD Actos Jurídicos Documentados 1,2% sobre el precio de la compra, gastos de inscripción en el registro y notaría. Tiene a su disposición copia de la correspondiente ficha informativa de esta propiedad en nuestra oficina según Decreto 218/2005 de 11 de octubre.",
        rentalLicenseRef: "Лицензия на аренду Ref",
        agencyInformation: "Agency Information",
    },
};
